import React from "react"
import { connect } from "react-redux"
import QueryString from "query-string"
import _ from "lodash"
import { Row } from "antd"
import RoleList from "../../components/RoleList/roleList"
import CreateRolesForm from "./createRolesForm"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import {
  getRolesListByFilters,
  upsertRoles,
  deleteRoles,
  //   getAppUserDetails,
  resetState,
} from "appRedux/slices/rolesList"
import { getPermissions } from "appRedux/slices/permissions"
// import { getLocationData } from "appRedux/slices/location"
import Auxiliary from "../../util/Auxiliary"
import Chips from "components/CommonFilter/chips"
import { roleFilters } from "../../constants/uiConstants"
import { Col, Button } from "reactstrap"
import { Modal } from "react-bootstrap"
import "./styles.css"

class BrowseRoles extends ErrorBoundComponent {
  state = {
    selectedUser: {},
    roleData: {},
    stateLocationList: [],
    cityLocationList: [],
    filters: {
      appCode: this.props.appCode,
      pageSize:
        this.props.queryParams && this.props.queryParams["pageSize"]
          ? this.props.queryParams["pageSize"]
          : 10,
      currentPage:
        this.props.queryParams && this.props.queryParams["currentPage"]
          ? this.props.queryParams["currentPage"]
          : 1,
      searchAfter:
        this.props.queryParams && this.props.queryParams["searchAfter"]
          ? this.props.queryParams["searchAfter"]
          : null,
      searchText:
        this.props.queryParams && this.props.queryParams["searchText"]
          ? this.props.queryParams["searchText"]
          : "",
      searchType:
        this.props.queryParams && this.props.queryParams["searchType"]
          ? this.props.queryParams["searchType"]
          : "role_id",
      rangeSearchType:
        this.props.queryParams && this.props.queryParams["rangeSearchType"]
          ? this.props.queryParams["rangeSearchType"]
          : null,
      rangeSearchText:
        this.props.queryParams && this.props.queryParams["rangeSearchText"]
          ? this.props.queryParams["rangeSearchText"]
          : null,
      rangeSearchFrom:
        this.props.queryParams && this.props.queryParams["rangeSearchFrom"]
          ? this.props.queryParams["rangeSearchFrom"]
          : null,
      rangeSearchTo:
        this.props.queryParams && this.props.queryParams["rangeSearchTo"]
          ? this.props.queryParams["rangeSearchTo"]
          : null,
      createdDateFrom:
        this.props.queryParams && this.props.queryParams["createdDateFrom"]
          ? this.props.queryParams["createdDateFrom"]
          : null,
      createdDateTo:
        this.props.queryParams && this.props.queryParams["createdDateTo"]
          ? this.props.queryParams["createdDateTo"]
          : null,
      order:
        this.props.queryParams && this.props.queryParams["order"]
          ? this.props.queryParams["order"]
          : "desc",
    },
    previewUser: false,
  }

  componentDidMount() {
    if (!this.props.common.error) {
      let filters = _.deepClean(this.state.filters)

      this.props.dispatch(getRolesListByFilters(filters))
      this.props.dispatch(getPermissions())
      //   this.props.dispatch(getLocationData())

      const filterCount = Object.keys(_.deepClean(this.state.filters)).length
      this.setState({ filterCount })

      window.addEventListener("keydown", this._keyDownHandler)
    }
  }

  _keyDownHandler = ({ key }) => {
    if (key === "Enter" && this.state.showFilters === true) {
      return this._closeFilters()
    }
    if (key === "Escape" && this.state.showFilters === true) {
      this.setState({
        showFilters: false,
        showAdvancedFilters: false,
      })
    }
  }

  async componentDidUpdate() {
    if (this.props.refetchRoleData) {
      let filters = _.deepClean(this.state.filters)

      setTimeout(() => {
        this.props.dispatch(getRolesListByFilters(filters))
      }, 1000)
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetState())
    window.removeEventListener("keydown", this._keyDownHandler)
  }

  _getRolesUpsertForm = () => {
    if (
      this.state.formAction === "create" ||
      this.state.formAction === "update"
    ) {
      return (
        <CreateRolesForm
          onSubmit={this._onUpsert}
          data={this.state.roleData}
          formAction={this.state.formAction}
          userId={this.state.userId}
          currentUser={this.props.currentUser}
          permissionList={this.props.permissionList}
          // roleData={this.props.roleData && this.props.roleData.roles}
          // agencyList={this.props.agencyList}
          onCancel={() => this.setState({ showModal: false, roleData: null })}
        />
      )
    }
  }

  _handleFilterChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value

    if (type === "searchType") {
      newFilters["searchText"] = undefined
    }
    if (type === "searchText" || type === "order" || type === "creatorType") {
      this.setState({
        filters: newFilters,
      })
    } else {
      this.setState({
        filters: newFilters,
      })
    }
  }

  _searchUser = () => {
    // if (this.state.filters.searchType === "phone") {
    //   return this.props.dispatch(
    //     getAppUserDetails({
    //       phoneNumber: this.state.filters.searchText,
    //     })
    //   )
    // }
    let { filters } = this.state
    if (filters && filters.pageSize) {
      delete filters.currentPage
    }
    this.props.history.push(
      `/roles/browse?${QueryString.stringify(_.deepClean(this.state.filters))}`
    )
    this.props.dispatch(getRolesListByFilters(_.deepClean(this.state.filters)))
  }

  _removeFilter = filter => {
    const newFilters = {
      ...this.state.filters,
      [filter]: roleFilters[filter].defaultValue,
    }

    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/roles/browse?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getRolesListByFilters(_.deepClean(this.state.filters))
        )
      }
    )
  }

  _toggleAdvancedFilters = () => {
    this.setState({
      showAdvancedFilters: !this.state.showAdvancedFilters,
    })
  }

  _closeFilters = () => {
    this._searchUser()
    this.setState({
      showFilters: false,
      showAdvancedFilters: false,
      showForm: false,
    })
  }

  _modal = () => {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this._onModalCancel}
        footer={null}
        fullscreen={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modalTitle">{"Roles "}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>{this._getRolesUpsertForm()}</Row>
        </Modal.Body>
      </Modal>
    )
  }

  _onUpsert = async formData => {
    let data = {
      formData,
      query: {
        action: this.state.formAction,
        appCode: this.props.appCode,
        roleId: this.state.roleData?.roleId || "",
      },
    }
    //data.userType = formData.jotUserType % 10
    this._onModalCancel()
    this.props.dispatch(upsertRoles(data))
  }

  _onModalCancel = () => {
    this.setState({
      showForm: false,
      showModal: false,
      roleData: {},
    })
  }

  _toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  _showFilters = () => {
    this.setState({
      showFilters: true,
    })
  }

  _handleEditClick = role => {
    this.setState({
      showModal: true,
      formAction: "update",
      roleData: role,
    })
  }

  _handleDeleteRole = id => {
    this.props.dispatch(
      deleteRoles({
        id: id,
      })
    )
  }

  _onPageChange = value => {
    let newFilters = _.cloneDeep(this.state.filters)
    newFilters["currentPage"] = value
    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/roles/browse?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getRolesListByFilters(_.deepClean(this.state.filters))
        )
      }
    )
  }

  render() {
    return (
      <Auxiliary
        loading={this.props.loading}
        error={_.get(this.props, "common.error")}
      >
        <>
          <Chips
            showFilters={this.state.showFilters}
            showAdvancedFilters={this.state.showAdvancedFilters}
            filters={this.state.filters}
            search={this._closeFilters}
            removeFilter={this._removeFilter}
            handleFilterChange={this._handleFilterChange}
            type="role"
            toggleFilters={this._toggleFilters}
            toggleAdvancedFilters={this._toggleAdvancedFilters}
          />
          {!this.state.showModal && (
            <div className="text-sm-end" style={{ paddingBottom: "15px" }}>
              <Button
                color="primary"
                className="font-16 btn-block btn btn-primary"
                onClick={() => {
                  // if (
                  //   !this.props.currentUser?.permissions?.includes(
                  //     "EDIT_MANAGE_CMS_USER"
                  //   )
                  // ) {
                  //   toastr.error(NO_PERMISSION_MESSAGE)
                  //   return
                  // }
                  this.setState(
                    {
                      showModal: false,
                    },
                    () =>
                      this.setState({
                        formAction: "create",
                        showModal: true,
                        roleData: {},
                      })
                  )
                }}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Create Role
              </Button>
            </div>
          )}
          {this.props.rolesList && this.props.rolesList.length > 0 ? (
            <RoleList
              roleList={this.props.rolesList}
              handleEditClick={this._handleEditClick}
              handleDeleteRole={this._handleDeleteRole}
              onPageChange={this._onPageChange}
              total={this.props.total}
              searchAfter={this.props.searchAfter}
              isMobile={this.props.isMobile}
              currentPage={this.state.filters["currentPage"]}
              pageSize={this.state.filters["pageSize"]}
              currentUser={this.props.currentUser}
              filters={this.state.filters}
            />
          ) : (
            <div>No data available</div>
          )}
          {this.state.showModal && this._modal()}
        </>
      </Auxiliary>
    )
  }
}

function mapStateToProps(store, ownProps) {
  return {
    rolesList: _.get(store, "roles.roles"),
    refetchData: _.get(store, "roles.refetchData"),

    refetchRoleData: _.get(store, "roles.refetchRoleData"),
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
    permissionList: _.get(store, "permissions.permissionList"),
    total: _.get(store, "roles.total"),
    searchAfter: _.get(store, "appUser.searchAfter"),
    common: _.get(store, "common"),
    currentUser: _.get(store, "currentUser.currentUser.data"),
    isMobile: _.get(store, "common.isMobile"),
    loading: _.get(store, "roles.loading"),
    userDetails: _.get(store, "roles.roleDetails"),
    appCode: sessionStorage.getItem("appCode"),
  }
}

export default connect(mapStateToProps)(BrowseRoles)
